__webpack_require__.p = "/Poorna-Portfolio/";